import { render, staticRenderFns } from "./DropToAttachRoleToPositionDialog.vue?vue&type=template&id=407cb3c1"
import script from "./DropToAttachRoleToPositionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DropToAttachRoleToPositionDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports